import axiosInstance from "src/common/axiosInstance";

export function loadPipelineGoogleSheet(url) {
  return axiosInstance.post("/admin/pipelines/import/google-sheet", { url });
}

export function importPipelineRows(payload) {
  return axiosInstance.post("/admin/pipelines/import", payload);
}

export function updatePipelineRows(pipelineId, payload) {
  return axiosInstance.put(`/admin/pipelines/import/${pipelineId}`, payload);
}

export function exportPipelineRows(pipelineId) {
  return axiosInstance.get(`/admin/pipelines/import/${pipelineId}/export`, {
    responseType: "blob",
  });
}
